import { getFieldOnMainLanguage } from '@app/utils/languages';
import { Card, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { CheckedBorder } from '@app/components/CheckedBorder';
import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface MediaListItemProps {
  mediaObj: GenericObject;
  isMediaSelected(media: GenericObject): boolean;
  selectMedia(media: GenericObject): void;
}

export const MediaListItem = ({ selectMedia, mediaObj, isMediaSelected }: MediaListItemProps) => {
  return (
    <Card
      key={mediaObj.id as number}
      onClick={() => selectMedia(mediaObj)}
      sx={{
        minHeight: 95,
        cursor: 'pointer',
        marginBottom: 1,
        position: 'relative',
        border: isMediaSelected(mediaObj) ? '2px solid #B484FF' : '',
      }}>
      <div style={{ display: 'flex', height: 55, padding: 6 }}>
        <img
          style={{ maxWidth: 57, maxHeight: 32, marginRight: 10, marginTop: 5, borderRadius: 5 }}
          src={`${(mediaObj?.vod_file_base as GenericObject)?.path}`}
          alt="Logo"
        />
        <div style={{ width: '100%', marginRight: '1vw' }}>
          <Typography sx={{ fontSize: 14, height: '50%' }} gutterBottom>
            {getFieldOnMainLanguage(mediaObj?.title)}
          </Typography>
          {isMediaSelected(mediaObj) && <CheckedBorder />}
        </div>
        <Typography sx={{ fontSize: 10, marginRight: '2vw' }} color="text.secondary" gutterBottom>
          {mediaObj.date_created ? dayjs(mediaObj.date_created as string).format('DD/MM/YYYY') : ''}
        </Typography>
      </div>
      <div
        style={{
          display: 'flex',
          height: '50%',
          marginLeft: '73px',
        }}>
        <div style={{ marginRight: '1vw' }}>
          <Typography sx={{ fontSize: 10 }} color="text.secondary" gutterBottom>
            CATEGORY
          </Typography>
          <Typography sx={{ fontSize: 10, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
            {getFieldOnMainLanguage(mediaObj?.category) || '-'}
          </Typography>
        </div>
        <div style={{ flex: 1 }}>
          <Typography sx={{ fontSize: 10 }} color="text.secondary" gutterBottom>
            TOPIC
          </Typography>
          <Typography sx={{ fontSize: 10, fontWeight: 'bold' }} color="text.secondary" gutterBottom>
            {getFieldOnMainLanguage((mediaObj?.taxonomy as GenericObject).category_name) || '-'}
          </Typography>
        </div>
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            maxWidth: '540px',
            marginRight: '1vw',
            justifyContent: 'flex-end',
          }}>
          {(mediaObj?.companies as GenericObject[]).map((company) => (
            <Typography sx={{ fontSize: 10, marginLeft: '1vw' }} gutterBottom>
              {getFieldOnMainLanguage(company?.name)}
            </Typography>
          ))}
        </div>
      </div>
    </Card>
  );
};
